import { Grid, Switch } from "@mui/material";

const MDTypography = require("components/MDTypography").default;

export const AloveSwitch = ({title, subtitle, value, setValue, disabled = false}) => {
    return (
        <Grid container spacing={2} gap={3} alignItems="center">
            <Grid size={2}>
                <Switch
                disabled={disabled}
                checked={value}
                onChange={(e) => setValue(e.target.checked)}
                />
            </Grid>
            <Grid size="grow">
                <MDTypography variant="h6">{title}</MDTypography>
                <MDTypography variant="body2">{subtitle}</MDTypography>
            </Grid>
        </Grid>
    );
    }